import React, { useState } from 'react';
import { Card, CardHeader, CardTitle } from 'components/shadcn/ui/card';
import { HGTable } from 'components/HGTable';
import { useSearch, usePage, useSort } from 'components/HGTable/hooks';
import { columns, COMPANIES_LIST_LIMIT, COMPANY_PAGE_SIZE } from './constants';
import { useUsersList } from '../service';

const Companies = () => {
    const pageSize = COMPANY_PAGE_SIZE;
    const limit = COMPANIES_LIST_LIMIT;
    const { data: companies, isLoading } = useUsersList('companies', limit);
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState(1);
    const [filterBy, setFilterBy] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState('');
    const filteredCompanies = useSearch(
        companies?.items ?? [],
        search,
        filterBy
    );
    const companiesToShow = usePage(filteredCompanies, currentPage, pageSize);
    const sortedData = useSort(companiesToShow, sortField, sortDirection);

    return (
        <Card>
            <CardHeader>
                <CardTitle className="text-primary-foreground">
                    Companies
                </CardTitle>
            </CardHeader>
            <HGTable
                loading={isLoading}
                skeletonRows={20}
                columns={columns}
                data={sortedData}
                search={search}
                setSearch={setSearch}
                filterBy={filterBy}
                setFilterBy={setFilterBy}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageSize={pageSize}
                totalItems={filteredCompanies?.length}
                sortField={sortField}
                setSortField={setSortField}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                canFilter={true}
                canSearch={true}
                onSearchChange={(e) => {
                    setSearch(e);
                }}
            />
        </Card>
    );
};

export default Companies;
